import React from 'react';
import Link from '../Link';

const FooterGroupLinks = ({ item }) => {
  const { id, label, childrenLinks } = item;
  return (
    <div className="group-links">
      <h4 id={id}>{label}</h4>
      {childrenLinks && (
        <div className="links">
          <ul aria-labelledby={id}>
            {childrenLinks.map((item, index) => (
              <li key={item.id + '' + index}>
                <Link to={item.link}>{item.label ? item.label : item.link.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FooterGroupLinks;
